import { Backend, getQueryParamValue } from '@shared/datastore/core';
import { EntriesGetResultApi } from 'api-typings/contests/contests';

declare module '../core/backend' {
  interface BackendApiFetchTypes {
    contestEntries: EntriesGetResultApi;
  }
}

export const contestEntriesBackend: Backend<'contestEntries'> = {
  fetch: (_, entryIds, query) => ({
    endpoint: `contests/0.1/entries`,
    params: {
      entries: entryIds || [],
      contests: query ? getQueryParamValue(query, 'contestId') : [],
      statuses: query ? getQueryParamValue(query, 'status') : [],
      // Owner of contest
      owners: query ? getQueryParamValue(query, 'contestOwnerId') : [],
      // Owner of entry
      entrants: query ? getQueryParamValue(query, 'ownerId') : [],
    },
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/contest-entries/contest-entries.backend.ts